// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"8d552431","353":"7f00b2b7","367":"707b39b1","379":"3d4a4f52","840":"ae8da3dd","871":"fa2e34a0","990":"3a6993c1"}[chunkId] + ".chunk.js";
};